<template>
  <DialogHeader>
    <WarningIcon />
    <DialogTitle>Direct Payment</DialogTitle>
    <DialogDescription>Only proceed if you have proof of payment.</DialogDescription>
  </DialogHeader>
  <p>A direct payment is a payment that happened outside of LayUp.</p>
  <p>Creating a direct payment will reduce the order balance.</p>
  <p>
    Only use this to record contributions toward the order that you received directly (i.e., payments that did not go
    through LayUp).
  </p>
  <div class="h-[1px] w-full my-4 bg-grey-light-200" />

  <DialogFooter>
    <Button @click="proceedToCapture">Proceed</Button>
  </DialogFooter>
</template>

<script setup lang="ts">
import WarningIcon from '@/components/icons/WarningIcon.vue';
import { Button } from '@/components/ui/button';
import { DialogDescription, DialogFooter, DialogHeader, DialogTitle } from '@/components/ui/dialog';

const emit = defineEmits(['proceed']);

const proceedToCapture = () => {
  emit('proceed');
};
</script>
